export const sections = {
  root: { title: '' },
  intelligence: { title: 'Intelligence' }
}
